import AccountSetting_02_IconSolid from '@/components/icons/AccountSetting_02_IconSolid';
import Analytics_01_IconSolid from '@/components/icons/Analytics_01_IconSolid';
import Calendar_04_IconSolid from '@/components/icons/Calendar_04_IconSolid';
import PackageIconSolid from '@/components/icons/PackageIconSolid';
import { NotificationCategory, NotificationsBarButtons, OwnerNotificationsListItemResponseDto } from '@/features/notifications/types/notifications-dto';
import { t } from 'i18next';

const getNotificationsConfig = (category: NotificationCategory) => {
	switch (category) {
		case NotificationCategory.Admin:
			return {
				label: t('main.notifications.category.admin'),
				icon: AccountSetting_02_IconSolid,
				iconColors: 'bg-error-100 fill-error-1000',
			};	
		case NotificationCategory.Calendar:
			return {
				label: t('main.notifications.category.calendar'),
				icon: Calendar_04_IconSolid,
				iconColors: 'bg-info-100 fill-info-1000',
			};	
		case NotificationCategory.Finances:
			return {
				label: t('main.notifications.category.finances'),
				icon: Analytics_01_IconSolid,
				iconColors: 'bg-success-100 fill-success-1000',
			};	
		case NotificationCategory.Orders:
			return {
				label: t('main.notifications.category.orders'),
				icon: PackageIconSolid,
				iconColors: 'bg-warning-100 fill-warning-1000',
			};	
	}
};

const filterNotificationsListByCategory = (data: {
    [key: string]: OwnerNotificationsListItemResponseDto[];
}, category?: NotificationCategory): [string, OwnerNotificationsListItemResponseDto[]][] | undefined => {
  if (!data) return;

  return Object.entries(data).map(([key, notifications]) => [
      key,
      category
        ? notifications.filter(n => n.category === category)
        : notifications,
    ]);
};

const getNotificationsListLength = (data: {
    [key: string]: OwnerNotificationsListItemResponseDto[];
}, category?: NotificationCategory) => {
  if (!data) return;

  const allNotifications = Object.values(data).flat();

  if (!category) return allNotifications.length;

  return allNotifications.filter(n => n.category === category).length;
};

const notificationBarCategoryMap: Partial<
		Record<NotificationsBarButtons, NotificationCategory>
	> = {
		[NotificationsBarButtons.Admin]: NotificationCategory.Admin,
		[NotificationsBarButtons.Finances]: NotificationCategory.Finances,
		[NotificationsBarButtons.Calendar]: NotificationCategory.Calendar,
		[NotificationsBarButtons.Orders]: NotificationCategory.Orders,
};

export const NotificationsUtils = {
	getNotificationsConfig,
	filterNotificationsListByCategory,
	getNotificationsListLength,
	notificationBarCategoryMap
};
